import React from 'react';
import classNames from 'classnames';
import config from 'config/config';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';

class Mentions extends React.Component {
  static propTypes = {
    users: PropTypes.array,
    currentIndex: PropTypes.number,
    error: PropTypes.bool,
    isLimiting: PropTypes.bool,
    select: PropTypes.func,
  };

  static defaultProps = {
    users: [],
    currentIndex: 0,
    error: false,
  };

  addLink(event, user) {
    event.preventDefault();
    this.props.select(user);
  }

  render() {
    const { error, isLimiting, users, currentIndex } = this.props;

    const classes = {
      mentions: true,
      'mentions-error': error || isLimiting,
    };

    return (
      <ul className={classNames(classes)}>
        {isLimiting
          ? <li>{i18n.t('You’ve reached the maximum number of mentions')}</li>
          : users.map((user, index) => (
            <li
              className={currentIndex === index ? 'mention-selected' : ''}
              key={user.userId}
              tabIndex="-1"
              onMouseDown={(e) => this.addLink(e, user)}
              onTouchStart={(e) => this.addLink(e, user)}
            >
              <img src={config.cdn.avatars + user.userImageHash + config.avatars.smallSuffix} />
              <div> {user.username} </div>
            </li>
          ))
        }
      </ul>
    );
  }
}

export default Mentions;

